const data = {
    products: [
        {
            id: 1,
            title: "Bellicious",
            ingredients: "Cheese, bell peppers, sliced almonds, black olives.",
            price: 9.95,
            img: "https://pngimg.com/uploads/pizza/pizza_PNG7117.png"
        },
        {
            id: 2,
            title: "Meathin",
            ingredients: "Cheese, thinly sliced meat, green olives, parsley.",
            price: 10.95,
            img: "https://pngimg.com/uploads/pizza/pizza_PNG7110.png"
        },

        {
            id: 3,
            title: "Kimchi",
            ingredients: "Cheese, Kimchi, sliced almods, olives, green onions.",
            price: 11.25,
            img: "https://pngimg.com/uploads/pizza/pizza_PNG7111.png"
        },

        {
            id: 4,
            title: "Mandarine",
            ingredients: "Mandarin orange, sliced almonds, olives, peas.",
            price: 9.95,
            img: "https://pngimg.com/uploads/pizza/pizza_PNG7113.png"
        },
        {
            id: 5,
            title: "Meathicc",
            ingredients: "Cheese, meat pieces, roasted garlic, peas, leeks.",
            price: 9.95,
            img: "https://pngimg.com/uploads/pizza/pizza_PNG7101.png"
        },

        {
            id: 6,
            title: "Musseland",
            ingredients: "Cheese, mussels, corn, bell peppers.",
            price: 13.95,
            img: "https://pngimg.com/uploads/pizza/pizza_PNG7100.png"
        },

        {
            id: 7,
            title: "Corn Fest",
            ingredients: "Cheese, corn, grounded turkey, olives, mushroom.",
            price: 9.95,
            img: "https://pngimg.com/uploads/pizza/pizza_PNG7099.png"
        },
        {
            id: 8,
            title: "Crazy Tomato",
            ingredients: "Cheese, tomato, olives, bell peppers.",
            price: 8.95,
            img: "https://pngimg.com/uploads/pizza/pizza_PNG7115.png"
        },

        {
            id: 9,
            title: "Sausage ",
            ingredients: "Cheese, sausages, olives, bell peppers.",
            price: 12.95,
            img: "https://pngimg.com/uploads/pizza/pizza_PNG7120.png"
        },
        {
            id: 10,
            title: "Cooleroni ",
            ingredients: "Cheese, pepperoni, olives, parsley.",
            price: 10.95,
            img: "https://pngimg.com/uploads/pizza/pizza_PNG7121.png"
        },
        {
            id: 11,
            title: "White sky",
            ingredients: "Cheese, yellow peppers, olives, parsley.",
            price: 9.95,
            img: "https://pngimg.com/uploads/pizza/pizza_PNG7112.png"
        },
        {
            id: 12,
            title: "King's Pizza",
            ingredients: "Cheese, King trumpet mushtroom, grounded turkey, peas.",
            price: 10.95,
            img: "https://pngimg.com/uploads/pizza/pizza_PNG7118.png"
        },



    ]
}
export default data;